import React, { useState, useRef, useEffect } from 'react'
import { Breadcrumb, message } from 'antd'
import { cdnImg } from 'meinian-package/src/utils/image'
import moment from 'moment'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import ImageDetail from 'view/detail/imageDetail'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import request from 'meinian-package/src/utils/request'
import { targetCategory } from 'view/common'
import TargetCategory from './targetCategory'
import User from './user'
import styles from './index.module.less'

export default ({ onBack, currentTask }) => {
  const [params, setParams] = useState({})
  const $masonry = useRef()
  return <div className={styles['mn-choose-task-inspiration']}>
    <div className="mn-choose-task-inspiration-header">
      <Breadcrumb className="mn-breadcrumb">
        <Breadcrumb.Item><span style={{ cursor: 'pointer' }} onClick={() => onBack()}>选款任务(Beta)</span></Breadcrumb.Item>
        <Breadcrumb.Item>{currentTask.missionName}</Breadcrumb.Item>
      </Breadcrumb>
    </div>
    <div className="mn-choose-task-inspiration-filter">
      <TargetCategory
        value={params.targetIdList?.[0]}
        onChange={(val) => setParams({ targetIdList: [val] })}
        currentTask={currentTask}
      />
      <User value={params.userIdList} onChange={userIdList => setParams(pre => ({ ...pre, userIdList }))} missionId={currentTask.id} />
    </div>
    <div className="mn-choose-task-inspiration-list">
      <MNWaterfallApi
        renderItem={CardImage}
        gutter={24}
        cardProps={{
          initSubColls: () => {
            $masonry.current?.init()
          },
        }}
        url="/zhikuan/ins/blog/mission/list-mission-blog"
        method="post"
        params={{
          missionId: currentTask.id,
          ...params,
        }}
        ref={$masonry}
        emptyText="暂无相关款式"
        emptyType="task"
      />
    </div>

  </div>
}

const CardImage = ({
  mainUrl,
  columnWidth,
  item,
  infoHeight = 24,
  unionId,
  sourceTime,
  onDeleteItem,
  outerIndex,
  onClickCard,
  total,
  data,
  isBatch,
  source,
  onFeedback,
  ...props }) => {
  const remote = () => {
    ModalConfirm.show({
      title: '确认移除',
      content: '是否移除当前关联任务',
      onOk: async () => {
        request.post('/zhikuan/ins/blog/mission/blog-cancel-related-target', { collectId: item.collectId, targetIdList: [item.targetId] }).then(success => {
          if (success) {
            message.success('成功')
            props.onResize()
            props.onItemDataChange()
            props.initSubColls && props.initSubColls()
            onDeleteItem(item)
          }
        })
      },
    })
  }
  const [visibleDetail, setVisibleDetail] = useState(false)
  const [index, setIndex] = useState(outerIndex)

  useEffect(() => {
    setIndex(outerIndex)
  }, [outerIndex])

  const onChangeIndex = (_outerIndex) => {
    setIndex(_outerIndex)
    props.onChangeIndex && props.onChangeIndex(_outerIndex)
  }

  const _onChange = (success, itemParams) => {
    if (success) {
      props.setData((pre) => {
        const i = pre.findIndex(_item => _item.imageGroupEntityId === itemParams?.entityId)
        if (i !== -1) {
          pre[i] = { ...pre[i], ...itemParams }
        } else {
          message.error('错误')
        }
        return [...pre]
      })
      props.onResize()
    }
  }
  return <div
    className="mn-choose-task-card"
    style={{
      width: columnWidth,
      height: Math.round((columnWidth * props.height) / props.width) + infoHeight,
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <div className="mn-choose-task-card-image-wrap" onClick={() => (item.blogDeleted !== 1 ? setVisibleDetail(true) : message.info('款式已不存在'))}>
      <img
        className="mn-choose-task-card-image"
        src={cdnImg(mainUrl, 500)}
      />
      <div
        className="mn-choose-task-card-mask"
        onClick={(e) => {
          e.stopPropagation()
          remote()
        }}
      >
        <div className="mn-choose-task-card-remote-task">从任务中移除</div>
      </div>
      {
        item.blogDeleted === 1 && <div className="mn-choose-task-card-image-wrap-status">已删除</div>
      }
    </div>
    <div className="mn-choose-task-card-footer">
      <div className="mn-choose-task-card-footer-left">
        {moment(item.collectTime).format('YYYY/MM/DD')}
        <span className="mn-choose-task-card-footer-user">
          <div className="mn-choose-task-card-footer-user-name">
            {item.collectUserName}
          </div>
          采集
        </span>
      </div>
      <div className="mn-choose-task-card-footer-label">{
      targetCategory(
        item?.targetInfo?.gender,
        item?.targetInfo?.rootCategory,
        item?.targetInfo?.category
      )
}</div>
    </div>
    {visibleDetail ? <ImageDetail
      visible={visibleDetail}
      onVisibleChange={(_visible) => { setVisibleDetail(_visible); setIndex(outerIndex) }}
      outerIndex={index}
      listLength={total || data.length}
      onChangeIndex={onChangeIndex}
      blogId={data?.[index].imageGroupEntityId}
      inspirationId={data?.[index].inspirationId}
      collectId={data?.[index].collectId}
      onChange={_onChange}
      onDeleteItem={props.onDeleteItem}
      initWaterfall={props.initWaterfall}
      initSubColls={props.initSubColls}
    /> : null}
  </div>
}
